export default "__VITE_ASSET__f8255272__"